<!-- 产品质检报告 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1" class="head-text">样式设置</MenuItem>
                <MenuItem name="2" class="head-text">内容设置</MenuItem>
                <MenuItem name="3" class="head-text">边距设置</MenuItem>
            </Menu>
            <div>
                <div v-if="name_id == 1">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">样式设置</div>
                        <FormItem label="样式设置">
                            <RadioGroup v-model="newFormData.content.style_set">
                                <Radio label="1">轮播</Radio>
                                <Radio label="2">平铺</Radio>
                                <Radio label="3">单张预览</Radio>
                            </RadioGroup>
                        </FormItem>
                        <template v-if="newFormData.content.style_set == 1">
                            <div class="form-title">轮播图方式</div>
                            <FormItem label="轮播方式">
                                <RadioGroup
                                    v-model="newFormData.content.autoplay"
                                >
                                    <Radio label="1">自动播放</Radio>
                                    <Radio label="2">手动播放</Radio>
                                </RadioGroup>
                            </FormItem>
                            <div
                                v-if="newFormData.content.autoplay == 1"
                                class="form-title"
                            >
                                轮播图静止时间
                            </div>
                            <FormItem
                                v-if="newFormData.content.autoplay == 1"
                                label="静止时间"
                            >
                                <Input
                                    v-model="newFormData.content.time"
                                    placeholder="请输入静止时间"
                                >
                                    <span slot="append">S</span>
                                </Input>
                            </FormItem>
                        </template>
                        <template v-if="newFormData.content.style_set == 2">
                            <div class="form-title">平铺样式</div>
                            <div class="img-divs">
                                <div
                                    class="img-div"
                                    v-for="(item, index) in imgStyleList"
                                    :key="index"
                                    :class="
                                        newFormData.content.style_id == index
                                            ? 'style-active'
                                            : 'style-default'
                                    "
                                    @click="changeStyle(index, item)"
                                >
                                    <img
                                        class="w80"
                                        :src="
                                            newFormData.content.style_id ==
                                            index
                                                ? item.img_active
                                                : item.img
                                        "
                                    />
                                    <span>{{ item.text }}</span>
                                </div>
                            </div>
                        </template>
                    </Form>
                </div>
                <div class="mt24 mb24" v-if="name_id == 2">
                    <Form
                        :model="newFormData"
                        label-position="left"
                        :label-width="100"
                    >
                        <div class="form-title">报告标题</div>
                        <FormItem label="标题样式">
                            <RadioGroup
                                v-model="newFormData.content.style_value"
                            >
                                <Radio class="mr24" label="1">样式一</Radio>
                                <Radio class="mr24" label="2">样式二</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.style_value == 2"
                            label="文字位置"
                        >
                            <RadioGroup
                                v-model="newFormData.content.position"
                                type="button"
                            >
                                <Radio label="left"
                                    ><Icon type="md-menu"
                                /></Radio>
                                <Radio label="center"
                                    ><Icon type="md-funnel"
                                /></Radio>
                                <Radio label="right"
                                    ><Icon type="md-menu"
                                /></Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="标题文字">
                            <Input
                                v-model="newFormData.content.title"
                                placeholder="请输入标题文字"
                            ></Input>
                        </FormItem>
                        <FormItem label="文字大小">
                            <Input
                                v-model="newFormData.content.title_size"
                                placeholder="请输入文字大小"
                                ><span slot="append">PX</span></Input
                            >
                        </FormItem>
                        <FormItem label="标题颜色">
                            <ColorPicker
                                v-model="newFormData.content.title_color"
                            />
                        </FormItem>
                        <FormItem label="分割线颜色">
                            <ColorPicker
                                v-model="newFormData.content.title_border_color"
                            />
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.style_value == 1"
                            label="装饰颜色"
                        >
                            <ColorPicker
                                v-model="newFormData.content.dec_color"
                            />
                        </FormItem>
                        <FormItem label="标题背景">
                            <ColorPicker
                                v-model="newFormData.content.title_bg_color"
                            />
                        </FormItem>
                        <div class="form-title">质检名称</div>
                        <FormItem label="文字大小">
                            <Input
                                v-model="newFormData.content.text_size"
                                placeholder="请输入文字大小"
                                ><span slot="append">PX</span></Input
                            >
                        </FormItem>
                        <FormItem label="名称颜色">
                            <ColorPicker
                                v-model="newFormData.content.text_color"
                            />
                        </FormItem>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色">
                            <ColorPicker
                                v-model="newFormData.content.bg_color"
                            />
                        </FormItem>
                        <FormItem label="背景图">
                            <i-switch
                                v-model="newFormData.content.bg_value"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeBgValue"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.bg_value"
                            label="上传背景"
                        >
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.bg_img.picview"
                                    :src="newFormData.content.bg_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 3">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">内间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="下圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.bottom"
                            ></Slider
                        ></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            imgStyleList: [
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/1-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/1-2.png",
                    text: "1张图",
                    num: 1,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/2-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/2-2.png",
                    text: "2张图",
                    num: 2,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/3-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/3-2.png",
                    text: "3张图",
                    num: 3,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/4-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/4-2.png",
                    text: "4张图",
                    num: 4,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/5-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/5-2.png",
                    text: "2张图平分",
                    num: 2,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/6-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/6-2.png",
                    text: "3张图平分",
                    num: 3,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/7-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/7-2.png",
                    text: "4张左右平分",
                    num: 4,
                },
                {
                    img: "https://suyuan.hulianzaowu.com/icon/diys/8-1.png",
                    img_active:
                        "https://suyuan.hulianzaowu.com/icon/diys/8-2.png",
                    text: "4张上下平分",
                    num: 4,
                },
            ],
        };
    },
    mounted() {},
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        changeStyle(index, item) {
            this.newFormData.content.style_id = index;
            this.newFormData.content.imgList = [];
            for (let i = 0; i < item.num; i++) {
                this.newFormData.content.imgList.push({
                    value: "",
                    picview: "",
                });
            }
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.img-divs {
    padding: 12px 0 0 12px;
    border: 1px solid #dadada;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.img-div {
    margin: 0 12px 12px 0;
    width: 100px;
    height: 100px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.w80 {
    width: 80px;
}
.style-active {
    border: 1px solid #ff761d;
    color: #ff761d;
}
.style-default {
    border: 1px solid #dadada;
    color: #333333;
}
/* RadioGroup */
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #fff;
    border-color: #ff761d;
    color: #ff761d;
    box-shadow: -1px 0 0 0 #ff761d;
}
::v-deep .ivu-radio-group-button :hover {
    color: #ff761d;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
</style>